export const FETCH_LIMIT = [
  { key: 0, text: "5", value: 5 },
  { key: 1, text: "10", value: 10 },
  { key: 2, text: "25", value: 25 },
  { key: 3, text: "50", value: 50 },
  { key: 4, text: "75", value: 75 },
  { key: 5, text: "100", value: 100 }
];

export const BATCH_PUBLISH_OFSET = 20